// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24DcP","left":"styles_left__1g64W","desktopActions":"styles_desktopActions__2sgzE","title":"styles_title__2um7S"};